import React, { useState } from "react";

const Failrechargehistory = () => {
  const [status, setStatus] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  const transactionData = [
    {
      srNo: 1,
      transactionId: "TXN207480129",
      userName: "Deepankar Kushwaha",
      userMobile: "9795225773",
      rechargeMobile: "9795225773",
      rechargePersonName: "Deepankar Kushwaha",
      operatorName: "Kotak Mahindra Bank Credit Card",
      amount: 60000,
      message: "Success",
      rechargeDate: "11/29/2024 2:06:56 PM",
      rechargeType: "Credit Card",
      status: "Success",
    },
    // Add more transactions if needed
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Status:", status);
    console.log("Transaction Type:", transactionType);

    // Filter data based on the selected filters (status and transaction type)
    const filtered = transactionData.filter((txn) => {
      return (
        (status ? txn.status.toLowerCase() === status.toLowerCase() : true) &&
        (transactionType
          ? txn.rechargeType.toLowerCase() === transactionType.toLowerCase()
          : true)
      );
    });
    setFilteredTransactions(filtered);
  };

  const containerStyle = {
    padding: "20px",
    backgroundColor: "#f4f4f9",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "1200px",
    margin: "0 auto",
    fontSize: "14px",
  };

  const formGroupStyle = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "15px",
    width: "200px",
  };

  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
    fontSize: "14px",
  };

  const selectStyle = {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    marginBottom: "15px",
  };

  const buttonStyle = {
    padding: "4px 8px", // Reduced padding for a smaller button
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px", // Smaller font size
    width: "auto",
    marginTop: "20px", // Space between form and button
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    fontSize: "14px",
    borderRadius: "8px",
    overflow: "hidden",
  };

  const thTdStyle = {
    border: "1px solid #ddd",
    padding: "12px",
    textAlign: "left",
    color: "#333",
  };

  const thStyle = {
    backgroundColor: "#f1f1f1",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyle}>
      <h2
        style={{ textAlign: "center", marginBottom: "20px", fontSize: "18px" }}
      >
        Activate Member Transaction
      </h2>

      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={formGroupStyle}>
            <label style={labelStyle}>Status</label>
            <select
              style={selectStyle}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">--Select Status--</option>
              <option value="success">Success</option>
              <option value="failure">Failure</option>
            </select>
          </div>

          <div style={formGroupStyle}>
            <label style={labelStyle}>Transaction Type</label>
            <select
              style={selectStyle}
              value={transactionType}
              onChange={(e) => setTransactionType(e.target.value)}
            >
              <option value="">--Select Transaction Type--</option>
              <option value="recharge">Recharge</option>
              <option value="d2hrecharge">D2H Recharge</option>
              <option value="data card recharge">Data Card Recharge</option>
            </select>
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </div>
      </form>

      {/* Table displaying filtered transaction history */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Sr. No.</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Transaction Id</th>
            <th style={{ ...thTdStyle, ...thStyle }}>User Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>User Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Person Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Operator Name</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Message</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Date</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Recharge Type</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredTransactions.length > 0 ? (
            filteredTransactions.map((txn) => (
              <tr key={txn.srNo}>
                <td style={thTdStyle}>{txn.srNo}</td>
                <td style={thTdStyle}>{txn.transactionId}</td>
                <td style={thTdStyle}>{txn.userName}</td>
                <td style={thTdStyle}>{txn.userMobile}</td>
                <td style={thTdStyle}>{txn.rechargeMobile}</td>
                <td style={thTdStyle}>{txn.rechargePersonName}</td>
                <td style={thTdStyle}>{txn.operatorName}</td>
                <td style={thTdStyle}>{txn.amount}</td>
                <td style={thTdStyle}>{txn.message}</td>
                <td style={thTdStyle}>{txn.rechargeDate}</td>
                <td style={thTdStyle}>{txn.rechargeType}</td>
                <td style={thTdStyle}>{txn.status}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" style={thTdStyle}>
                No transactions available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Failrechargehistory;
